export const SUPPORT_LINK = 'https://support.ourpact.com'
